import gql from 'graphql-tag';
import { short as shortUser } from './user';

const highlight = gql`
  fragment SearchResultHighlight on SearchResultHighlight {
    content: result
    highlightPositions {
      start
      end
    }
  }
`;

const searchResultHighlights = gql`
  fragment SearchResultHighlights on SearchResultHighlights {
    attachments {
      ...SearchResultHighlight
    }
    content {
      ...SearchResultHighlight
    }
    name {
      ...SearchResultHighlight
    }
    urls {
      ...SearchResultHighlight
    }
  }

  ${highlight}
`;

export const searchResult = gql`
  fragment SearchResult on SearchResult {
    id
    cardId
    content
    channel {
      id
      slug
      name
      type
    }
    date: createdAt
    highlights {
      ...SearchResultHighlights
    }
    name
    type
    user {
      ...ShortUser
    }
  }

  ${shortUser}
  ${searchResultHighlights}
`;
